import "./register.css"
import logo from "../../../assets/logo.svg"
import register from "../../../assets/register_img.png"
import individual from "../../../assets/individual.png"
import account from "../../../assets/account.png"
import custodial from "../../../assets/custodial.png"
import ira from "../../../assets/ira.png"
import speciality from "../../../assets/speciality.png"
import hr from "../../../assets/hr.svg"
import React, {useEffect, useState} from "react";
import AccountModal from "../modal/AccountModal";
import IraModal from "../modal/IraModal";
import IndividualModal from "../modal/IndividualModal";
import Form from 'react-bootstrap/Form';
import {Link, useNavigate} from "react-router-dom";
import {connect} from 'react-redux';
import {setAppData} from '../../../redux/register_store';
import {useTranslation} from 'react-i18next';
import Logout from "../../logout/Logout";
import axios from "axios";
import {Spinner} from "react-bootstrap";
import i18n from "../../../i18n/i18n";
import show_pass from "../../../assets/show_pass.png"
import hide_pass from "../../../assets/hide_pass.png"

const HOST = `${process.env.REACT_APP_API_URL}/api/accounts`

function Register({appData, setAppData}) {
    const {t} = useTranslation()

    const [showModalJoinAcc, setShowModalJoinAcc] = useState(false);
    const [showModalIra, setShowModalIra] = useState(false);
    const [showModalIndividual, setShowModalIndividual] = useState(false);
    const [selectedJointType, setSelectedJointType] = useState('joint1');
    const [selectedSpecialtyType, setSelectedSpecialtyType] = useState('special1')
    const [selectedAccountType, setSelectedAccountType] = useState('individual');
    const [selectCountry, setSelectCountry] = useState([]);
    const [selectResidenceCountry, setSelectResidenceCountry] = useState([]);
    const [isReadyCountry, setIsReadyCountry] = useState(false)
    const navigate = useNavigate()
    const [referralsList, setReferralsList] = useState([]);
    const [isReadyHear, setIsReadyHear] = useState(false)
    const [showPassword, setShowPassword] = useState(false);
    const [showConfPass, setShowConfPass] = useState(false)

    const campaignSlug = window.campaign_slug || ''

    useEffect(() => {
        if (campaignSlug === 'DAWUL') {
            i18n.changeLanguage('aue');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [campaignSlug]);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/accounts/getCountries`, {
                headers: {
                    "ngrok-skip-browser-warning": "69420",
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            }
        )
            .then(({data}) => {
                const countryNames = data.map((country) => {
                    return {
                        value: country.cont_code,
                        label: country.cont_name
                    }
                });

                setSelectCountry(countryNames);
                setIsReadyCountry(true)
            })
            .catch((err) => {
                console.log(err.message);
            });

        if (appData.country_of_birth) {
            onChangeCountry(appData.country_of_birth)
        }

        if (appData.account_type) {
            handleAccountTypeSelection(appData.account_type)
        }

        if (appData.sub_account_type) {
            handleJointTypeSelection(appData.sub_account_type)
        }

        if (appData.sub_account_type) {
            handleSpecialtyTypeSelection(appData.sub_account_type)
        }

        if (!appData.hear_about_us && campaignSlug) {
            setAppData({...appData, hear_about_us: campaignSlug});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/accounts/getCountriesFiltered`, {
                headers: {
                    "ngrok-skip-browser-warning": "69420",
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            }
        )
            .then(({data}) => {
                const countryNames = data.map((country) => {
                    return {
                        value: country.cont_code,
                        label: country.cont_name
                    }
                });

                setSelectResidenceCountry(countryNames);
                setIsReadyCountry(true)
            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);

    const getClientIP = async () => {
        const response = await fetch('https://api.ipify.org?format=json')
        const data = await response.json()

        return {...appData, clientIP: data.ip}
    }

    const onChangeCountry = (value) => {
        setAppData({...appData, 'country_of_birth': value});
    }

    const onChangeCountryResidence = (value) => {
        setAppData({...appData, 'country_of_residence': value});
    }

    const onChangeCountryCitizenship = (value) => {
        setAppData({...appData, 'country_of_citizenship': value});
    }

    const hideJoinAccModal = () => {
        setShowModalJoinAcc(false)
    }

    const hideIraModal = () => {
        setShowModalIra(false)
    }

    const hideIndividualModal = () => {
        setShowModalIndividual(false)
    }

    const [formErrors, setFormErrors] = useState({
        email: '',
        password: '',
        confirm_password: '',
        hear_about_us: '',
        citizenship_status: '',
        country_of_birth: '',
        country_of_residence: '',
        country_of_citizenship: '',
        specialtyAccountType: ''
    });

    const isEmailValid = (email) => {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

        if (!email.includes("@")) {
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                email: t('errors.email_validation'),
            }));
            return false;
        }

        if (email.toLowerCase().endsWith(".ca")) {
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                email: t('errors.canadian_email_error'),
            }));
            return false;
        }

        return emailRegex.test(email);
    };

    const isPasswordValid = (password) => {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,15}$/;
        return passwordRegex.test(password);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        setFormErrors({
            email: '',
            password: '',
            confirm_password: '',
            hear_about_us: '',
            citizenship_status: '',
            country_of_birth: '',
            country_of_residence: '',
            country_of_citizenship: '',
            specialtyAccountType: ''
        });

        let isValid = true;

        if (!isEmailValid(appData.email)) {
            isValid = false;
        }

        if (!isPasswordValid(appData.password)) {
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                password: t('errors.invalid_password'),
            }));
            isValid = false;
        }

        if (appData.password !== appData.confirm_password) {
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                confirm_password: t('errors.conf_password_error'),
            }));
            isValid = false;
        }

        if (!appData.hear_about_us && !campaignSlug) {
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                hear_about_us: t('errors.hear_us_error'),
            }));
            isValid = false;
        }

        if (!appData.citizenship_status) {
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                citizenship_status: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!appData.specialtyAccountType && appData.account_type === "specialty" && (selectedSpecialtyType === "special1" || selectedSpecialtyType === "special4")) {
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                specialtyAccountType: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (appData.citizenship_status === "non_resident" || appData.citizenship_status === "ResidentAlien") {
            if (!appData.country_of_birth) {
                setFormErrors((prevErrors) => ({
                    ...prevErrors,
                    country_of_birth: t('errors.required_field'),
                }));
                isValid = false;
            }

            if (!appData.country_of_residence && appData.country_of_residence) {
                setFormErrors((prevErrors) => ({
                    ...prevErrors,
                    country_of_residence: t('errors.required_field'),
                }));
                isValid = false;
            }

            if (!appData.country_of_citizenship) {
                setFormErrors((prevErrors) => ({
                    ...prevErrors,
                    country_of_citizenship: t('errors.required_field'),
                }));
                isValid = false;
            }
        }

        if (isValid) {
            getAccountData();

            registerApp().then(r => navigate('/personal'))
        }
    };

    const handleInputChange = (e) => {
        const {name, value} = e.target;

        setAppData({...appData, [name]: value})
    };

    useEffect(() => {
        fetchReferralsList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchReferralsList = async () => {
        const URL = `${process.env.REACT_APP_API_URL}/api/accounts/getReferralsList`
        const response = await axios.get(URL, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            }
        })

        setReferralsList(response.data)
        setIsReadyHear(true)

        if (!appData.hear_about_us) {
            setAppData({...appData, hear_about_us: campaignSlug});
        }
    }

    const registerApp = async () => {
        const appData = await getClientIP()

        if (appData.app_id) return

        if (appData.account_type !== "speciality") {
            delete appData.specialtyAccountType
        }

        if (appData.sub_account_type === 'omnibus'){
            appData.account_type = 'individual'
        }

        const response = await axios.post(HOST, appData, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            }
        });

        setAppData({...appData, app_id: response.data.app_id});
    };

    useEffect(() => {
        getAccountData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedAccountType]);

    const handleAccountTypeSelection = (accountType) => {
        setSelectedAccountType(accountType);
        const subType = accountType === 'joint' ? 'joint1' : accountType === 'speciality' ? 'special1' : ''

        setAppData({
            ...appData,
            sub_account_type: subType,
            account_type: accountType
        });
    };

    const getAccountData = () => {
        return {
            account_type: selectedAccountType,
        };
    };

    const handleJointTypeSelection = (subAccountType) => {
        setSelectedJointType(subAccountType);

        setAppData({
            ...appData,
            sub_account_type: subAccountType
        });
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleCondPasswordVisibility = () => {
        setShowConfPass(!showConfPass)
    };

    const handleSpecialtyTypeSelection = (subSpecialtyAccountType) => {
        setSelectedSpecialtyType(subSpecialtyAccountType);

        let specialtyAccountType = 'C'

        if (subSpecialtyAccountType === 'special1') {
            if (['C', 'S'].includes(appData.specialtyAccountType)) {
                specialtyAccountType = appData.specialtyAccountType
            } else {
                specialtyAccountType = 'C'
            }
        } else if (subSpecialtyAccountType === 'special4') {
            if (['C', 'S', 'P'].includes(appData.specialtyAccountType)) {
                specialtyAccountType = appData.specialtyAccountType
            } else {
                specialtyAccountType = 'C'
            }
        } else {
            if (['trust1', 'trust2'].includes(appData.specialtyAccountType)) {
                specialtyAccountType = appData.specialtyAccountType
            } else {
                specialtyAccountType = 'trust2'
            }
        }

        setAppData({
            ...appData,
            sub_account_type: subSpecialtyAccountType,
            specialtyAccountType
        });
    };

    return (
        <div className="register">
            <div className="register_content">
                <div className="register_left_side">
                    <img src={logo} alt=""/>
                    <img style={{paddingTop: "12%"}} src={register} alt=""/>
                </div>
                <div className="register_right_side">
                    {appData.app_id &&
                        <Logout/>
                    }
                    <p className="register_header1">{t('register.user_registration')}</p>
                    <p className="register_header2">{t('register.for_limited')}</p>
                    <Link to="/login" style={{textDecoration: "none"}}><p
                        className="sign_in_app">{t('register.already_sign_in')}</p>
                    </Link>
                    <form onSubmit={handleSubmit}>
                        <div className="register_inputs">
                            <div className="register_small_inp">
                                <div className="register_inp_full_error">
                                    <input placeholder={t('register.email')} className="register_inp" type="text"
                                           name="email"
                                           value={appData.email}
                                           onChange={handleInputChange}
                                    />
                                    {formErrors.email && <p className="error">{formErrors.email}</p>}
                                </div>

                                <div className="register_inp_error">
                                    <div className="pass_icon">
                                        <input
                                            placeholder={t('register.password')}
                                            className="register_inp"
                                            type={showPassword ? 'text' : 'password'}
                                            name="password"
                                            value={appData.password}
                                            onChange={handleInputChange}
                                        />
                                        <i
                                            className="password-toggle-icon"
                                            onClick={togglePasswordVisibility}
                                        >
                                            <img
                                                className="password_icon"
                                                src={showPassword ? show_pass : hide_pass}
                                                alt={showPassword ? 'Hide Password' : 'Show Password'}
                                            />
                                        </i>
                                    </div>
                                    {formErrors.password && <p className="error">{formErrors.password}</p>}
                                </div>

                                <div className="register_inp_error">
                                    <div className="pass_icon">
                                        <input
                                            placeholder={t('register.confirm_password')}
                                            className="register_inp"
                                            type={showConfPass ? 'text' : 'password'}
                                            name="confirm_password"
                                            value={appData.confirm_password}
                                            onChange={handleInputChange}
                                        />
                                        <i
                                            className="password-toggle-icon"
                                            onClick={toggleCondPasswordVisibility}
                                        >
                                            <img
                                                className="password_icon"
                                                src={showConfPass ? show_pass : hide_pass}
                                                alt={showConfPass ? 'Hide Password' : 'Show Password'}
                                            />
                                        </i>
                                    </div>
                                    {formErrors.confirm_password &&
                                        <p className="error">{formErrors.confirm_password}</p>}
                                </div>
                            </div>
                            {!campaignSlug &&
                                <div className="register_inp_full_error">
                                    {
                                        isReadyHear ?
                                            <Form.Select
                                                aria-label="Default select example"
                                                name="hear_about_us"
                                                onChange={handleInputChange}
                                                value={appData.hear_about_us || campaignSlug}
                                            >
                                                <option value="" selected disabled>{t('register.hear_us')}</option>
                                                {referralsList.map((referral) => (
                                                    <option key={referral.id} value={referral.value}>
                                                        {referral.hear_about}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            : <Spinner animation="border" role="status" variant="personalData">
                                                <span className="visually-hidden">Loading...</span>
                                            </Spinner>

                                    }
                                    {isReadyCountry && formErrors.hear_about_us &&
                                        <p className="info_error">{formErrors.hear_about_us}</p>}
                                </div>
                            }
                            <div className="register_inp_full_error">
                                <Form.Select aria-label="Default select example"
                                             name="citizenship_status"
                                             value={appData.citizenship_status}
                                             onChange={handleInputChange}

                                >
                                    <option value="" selected disabled>{t('register.citizen_status')}</option>
                                    <option value="UsCitizen">U.S. Citizen</option>
                                    <option value="ResidentAlien">Resident Alien</option>
                                    <option value="non_resident">Non Resident</option>
                                </Form.Select>

                                {formErrors.citizenship_status && (
                                    <p className="error">{formErrors.citizenship_status}</p>
                                )}
                            </div>

                            {
                                (appData.citizenship_status === "non_resident" || appData.citizenship_status === "ResidentAlien") && (
                                    <>
                                        <div className="register_small_inp">

                                            <div className="personal_input_error" style={{textAlign: "center"}}>
                                                {
                                                    isReadyCountry ?
                                                        <select className="personal_country_select"
                                                                value={appData.country_of_birth}
                                                                onChange={(e) => onChangeCountry(e.target.value)}
                                                                name="country_of_birth">
                                                            <option value="" selected disabled>Country Of Birth</option>
                                                            {selectCountry.map((country, index) => <option
                                                                value={country.value}
                                                                key={index.toString()}>{country.label}</option>)}
                                                        </select>
                                                        : <Spinner animation="border" role="status" variant="personalData">
                                                            <span className="visually-hidden">Loading...</span>
                                                        </Spinner>
                                                }

                                                {isReadyCountry && formErrors.country_of_birth &&
                                                    <p className="info_error">{formErrors.country_of_birth}</p>}
                                            </div>

                                            <div className="personal_input_error" style={{textAlign: "center"}}>
                                                {
                                                    isReadyCountry ?
                                                        <select className="personal_country_select"
                                                                value={appData.country_of_citizenship}
                                                                onChange={(e) => onChangeCountryCitizenship(e.target.value)}
                                                                name="country_of_citizenship">
                                                            <option value="" selected disabled>Country of Citizenship</option>
                                                            {selectCountry.map((country, index) => <option
                                                                value={country.value}
                                                                key={index.toString()}>{country.label}</option>)}
                                                        </select>
                                                        : <Spinner animation="border" role="status" variant="personalData">
                                                            <span className="visually-hidden">Loading...</span>
                                                        </Spinner>
                                                }

                                                {isReadyCountry && formErrors.country_of_citizenship &&
                                                    <p className="info_error">{formErrors.country_of_citizenship}</p>}
                                            </div>

                                            {appData.citizenship_status === "non_resident" &&
                                                <div className="register_inp_full_error" style={{textAlign: "center"}}>
                                                    {
                                                        isReadyCountry ?
                                                            <select className="personal_country_select"
                                                                    value={appData.country_of_residence}
                                                                    onChange={(e) => onChangeCountryResidence(e.target.value)}
                                                                    name="country_of_residence">
                                                                <option value="" selected disabled>Country Of Residence</option>
                                                                {selectResidenceCountry.map((country, index) => <option
                                                                    value={country.value}
                                                                    key={index.toString()}>{country.label}</option>)}
                                                            </select>
                                                            : <Spinner animation="border" role="status"
                                                                       variant="personalData">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </Spinner>
                                                    }

                                                    {isReadyCountry && formErrors.country_of_residence &&
                                                        <p className="info_error">{formErrors.country_of_residence}</p>}
                                                </div>
                                            }
                                        </div>
                                    </>
                                )
                            }

                        </div>
                        <p className="register_account_types">{t('register.type_account')}</p>
                        <div className="register_types">
                            <div className="types" onClick={() => handleAccountTypeSelection('individual')}>
                                <img
                                    className={`individual_img ${selectedAccountType === 'individual' ? 'selected' : 'hovers_img'}`}
                                    src={individual} alt=""/>
                                <p className="types_text">{t('register.individual')}</p>
                            </div>
                            <div className="types" onClick={() => {
                                handleAccountTypeSelection('joint');
                                setShowModalJoinAcc(true);
                            }}>
                                <img
                                    className={`individual_img ${selectedAccountType === 'joint' ? 'selected' : 'hovers_img'}`}
                                    src={account} alt=""/>
                                <p className="types_text"
                                   style={{marginTop: "10%"}}>{t('register.joint_account_type')}</p>
                            </div>

                            <div className={appData.citizenship_status === "non_resident" ? "non_types" : "types"}
                                 onClick={() => handleAccountTypeSelection('custodial')}>
                                <img
                                    className={`individual_img ${selectedAccountType === 'custodial' ? 'selected' : 'hovers_img'}`}
                                    src={custodial} alt=""/>
                                <p className="types_text">{t('register.custodial')}</p>
                            </div>
                            <div className={appData.citizenship_status === "non_resident" ? "non_types" : "types"}
                                 onClick={() => {
                                     handleAccountTypeSelection('IRA');
                                     setShowModalIra(true);
                                 }}>
                                <img
                                    className={`individual_img ${selectedAccountType === 'IRA' ? 'selected' : 'hovers_img'}`}
                                    src={ira} alt=""/>
                                <p className="types_text">{t('register.ira')}</p>
                            </div>

                            <div className="types" onClick={() => {
                                handleAccountTypeSelection('speciality');
                                setShowModalIndividual(true);
                            }}>
                                <img
                                    className={`individual_img ${selectedAccountType === 'speciality' ? 'selected' : 'hovers_img'}`}
                                    src={speciality} alt=""/>
                                <p className="types_text">{t('register.specialty_account_type')}</p>
                            </div>
                        </div>
                        <img style={{width: "100%"}} src={hr} alt=""/>
                        <div className="register_btn">
                            <button className="register_continue_btn" type="submit">
                                <span className="register_continue_btn_text">{t('next_btn')}</span>
                            </button>

                            <AccountModal selectedJointType={selectedJointType}
                                          onSelectJointType={handleJointTypeSelection} show={showModalJoinAcc}
                                          hideJoinAccModal={hideJoinAccModal}/>
                            <IraModal showIra={showModalIra} hideIraModal={hideIraModal}/>
                            <IndividualModal selectedSpecialtyType={selectedSpecialtyType}
                                             onSelectSpecialtyType={handleSpecialtyTypeSelection}
                                             showIndividual={showModalIndividual}
                                             hideIndividualModal={hideIndividualModal}/>
                        </div>
                        <div style={{marginTop: "5%"}}>
                            <p style={{fontSize: "14px"}}>{t('register.important_info')}</p>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    appData: state.appData,
});

const mapDispatchToProps = {
    setAppData,
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);